// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box !important;
}

#magicform-widget-container {
  width: 100vw;
  height: 100vh;
  display: flex !important;
  flex-direction: column-reverse !important;
  align-items: flex-end !important;
  box-sizing: border-box !important;
  pointer-events: none !important;
}

.magicform-widget-position-bottom-left {
  position: fixed !important;
  bottom: 20px !important;
  left: 20px !important;
}

.magicform-widget-position-bottom-right {
  position: fixed !important;
  bottom: 20px !important;
  right: 20px !important;
}

.magicform-chat-icon-content {
  margin-left: 5px !important;
  margin-bottom: 5px !important;
  font-family: sans-serif !important;
  color: ghostwhite !important;
  font-size: 1.5rem !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/Widget/Widget.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,yCAAyC;EACzC,gCAAgC;EAChC,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,kCAAkC;EAClC,4BAA4B;EAC5B,4BAA4B;AAC9B","sourcesContent":["* {\n  box-sizing: border-box !important;\n}\n\n#magicform-widget-container {\n  width: 100vw;\n  height: 100vh;\n  display: flex !important;\n  flex-direction: column-reverse !important;\n  align-items: flex-end !important;\n  box-sizing: border-box !important;\n  pointer-events: none !important;\n}\n\n.magicform-widget-position-bottom-left {\n  position: fixed !important;\n  bottom: 20px !important;\n  left: 20px !important;\n}\n\n.magicform-widget-position-bottom-right {\n  position: fixed !important;\n  bottom: 20px !important;\n  right: 20px !important;\n}\n\n.magicform-chat-icon-content {\n  margin-left: 5px !important;\n  margin-bottom: 5px !important;\n  font-family: sans-serif !important;\n  color: ghostwhite !important;\n  font-size: 1.5rem !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
